import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Input, Icon, Button } from '@iq/react-components';
import SelectPollingDateRange from '../../../../SelectPollingDateRange';
import TagSelect from '../../../../TagSelect';

const Filters = ({ filterValue, setFilterValue, panelId, hideDateTimePicker, hideSearch }) => {
  return useMemo(
    () => (
      <>
        {!hideDateTimePicker && <SelectPollingDateRange panelId={panelId} />}
        {!hideSearch && (
          <Input
            className="visualizations-panel-search"
            type="text"
            placeholder="Search..."
            value={filterValue}
            onChange={(event) => setFilterValue(event.target.value)}
          />
        )}
      </>
    ),
    [panelId, filterValue, setFilterValue, hideDateTimePicker, hideSearch]
  );
};

const TagFilters = ({ availableTags, includeTags = [], setTagFilter }) => {
  const [tagValue, setTagValue] = useState(includeTags);

  useEffect(() => {
    setTagFilter(() => tagValue || []);
  }, [JSON.stringify(tagValue)]);

  useEffect(() => {
    setTagValue(() => includeTags);
  }, [JSON.stringify(includeTags)]);

  const isFixedTagOption = useCallback(({ value }) => includeTags.includes(value), [includeTags]);

  return (
    <div className="filter-tools-select-wrapper">
      <TagSelect
        onChange={setTagValue}
        value={tagValue}
        creatable={false}
        popout
        availableTags={availableTags}
        menuXPlacement="left"
        isOptionDisabled={isFixedTagOption}
        backspaceRemovesValue={includeTags.length === 0}
        hideMenu={includeTags.length > 0}
        category="visualizations"
        noOptionsMessage={() => 'No tags available'}
      />
    </div>
  );
};
const getHiddenMap = (hiddenItems = []) =>
  hiddenItems.reduce((acc, key) => {
    acc[key] = true;
    return acc;
  }, {});
const VisualizationsHeader = ({
  filterValue,
  format,
  hideFilters,
  isFullScreen,
  setFilterValue,
  panelId,
  anySelected,
  allSelected,
  toggleAllSelected,
  openSignalViewer,
  exportTimeSeries,
  signalViewerVisualizations,
  availableTags,
  includeTags,
  setTagFilter,
  showTagFilter = true,
  hideToolbar = true,
  hiddenToolbarItems = [],
}) => {
  if (hideToolbar) return null;

  const hidden = getHiddenMap(hiddenToolbarItems);

  return (
    <div className={`visualizations-panel-header ${isFullScreen ? 'widest' : format}`}>
      <div className="visualizations-panel-toolbar primary">
        {signalViewerVisualizations && !hidden.signalViewerTools && (
          <div className="signal-viewer-tools">
            <div
              className="signal-viewer-tools-select-all-label"
              onClick={toggleAllSelected}
            >
              <Icon
                className={`select-all ${allSelected ? 'checked' : ''}`}
                icon={allSelected ? 'he-checkbox-selected' : 'he-checkbox'}
                size="s"
              />
              <span className="title">Select all</span>
            </div>

            <Button
              onClick={openSignalViewer}
              activity="secondary"
              icon={<Icon icon="he-signal" />}
              tooltip="Signal Viewer"
              slim
            />

            {anySelected && (
              <Button
                onClick={exportTimeSeries}
                activity="secondary"
                icon={<Icon icon="he-download" />}
                tooltip="Download"
                slim
              />
            )}
          </div>
        )}

        <div className="filter-tools">
          <Filters
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            panelId={panelId}
            hideDateTimePicker={hidden.datetimepicker}
            hideSearch={hidden.search}
          />

          {!hideFilters && showTagFilter && !hidden.tags && (
            <TagFilters
              availableTags={availableTags}
              includeTags={includeTags}
              setTagFilter={setTagFilter}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default VisualizationsHeader;
